import { render, staticRenderFns } from "./special-good.vue?vue&type=template&id=3d46b3a0&scoped=true"
import script from "./special-good.vue?vue&type=script&lang=ts"
export * from "./special-good.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d46b3a0",
  null
  
)

export default component.exports